<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="register_info">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body">
          <img class="modal_icon_alert" src="static/images/subscribe.svg" />
          <p>{{ getTranslations.home_modals_simplify_registration_text }}</p>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'simplify-registration',
  created() {
    this.showModal();
  },
  methods: {
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#register_info').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/SimplifyRegistration.vue